import { render, staticRenderFns } from "./assinaturas.vue?vue&type=template&id=1b1878ec&scoped=true"
import script from "./assinaturas.vue?vue&type=script&lang=js"
export * from "./assinaturas.vue?vue&type=script&lang=js"
import style0 from "./assinaturas.vue?vue&type=style&index=0&id=1b1878ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1878ec",
  null
  
)

export default component.exports